import React from 'react';
import { withTheme } from 'styled-components';
export var EcologiaIcon = function EcologiaIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "284px",
    height: "267px",
    viewBox: "0 0 284 267",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Ecologi\u0301a"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Ecologi\u0301a",
    transform: "translate(-37.000000, -1.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "13"
  }, React.createElement("g", {
    id: "Ecolog\xEDa",
    transform: "translate(44.000000, 8.000000)"
  }, React.createElement("g", {
    id: "Group"
  }, React.createElement("path", {
    d: "M28.17,119.7 C7.15,106.04 -7.36,84.15 4.92,57.58 C17.2,31.01 68.02,26.37 91.21,0.31 C112.23,24.29 113.37,64.11 94.59,95.48 C81.94,116.6 58.84,119.43 46.82,119.39",
    id: "Path"
  }), React.createElement("path", {
    d: "M120.38,17.99 C129.96,15.51 140.02,14.19 150.38,14.19 C216.32,14.19 269.78,67.65 269.78,133.59 C269.78,199.53 216.32,252.99 150.38,252.99 C84.44,252.99 30.98,199.53 30.98,133.59 C30.98,96.5 47.89,63.36 74.43,41.46",
    id: "Path"
  }), React.createElement("path", {
    d: "M269.77,141.06 L252.1,141.06 L240.32,123.39 L228.54,123.39 L222.65,129.28 L204.98,129.28 L175.52,99.82 L134.28,99.82 L134.28,88.04 C134.28,75.03 144.83,64.48 157.84,64.48 L169.62,64.48 L181.4,52.7 L210.86,52.7 L222.64,40.92",
    id: "Path"
  }), React.createElement("polygon", {
    id: "Path",
    points: "181.41 211.75 163.73 211.75 163.73 170.51 151.95 158.73 128.39 158.73 128.39 141.06 146.06 123.38 175.52 123.38 204.97 152.84 204.97 188.19"
  }))))));
};
export default withTheme(EcologiaIcon);